import { render, staticRenderFns } from "./PacketBrowser.vue?vue&type=template&id=7450d846"
import script from "./PacketBrowser.vue?vue&type=script&lang=ts"
export * from "./PacketBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports